import styled from "styled-components";
import MultiCheckBoxGroup from "../witadmin/CRUD/Common/MultiCheckBoxGroup";
import { APP_COLORS } from "../witadmin/Common/constants";
import ArrowDown from "../witadmin/icons/arrowDown";

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 1rem;
  > * {
    margin: 0 5px;
  }
  :last-child {
    margin-right: 5px;
  }
`;

export const ResultContainer = styled.div`
  margin: 16px;
`;

export const MessageContainer = styled.span`
  font-weight: 600;
`;

export const OptionsTableContainer = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
`;

export const StyledMultiCheckBoxGroup = styled(MultiCheckBoxGroup)<{ restrictedHeight: boolean }>`
  ${props => (props.restrictedHeight ? "height: 420px;  overflow: auto;" : "")}
`;

export const CheckAllControlFilter = styled.div<{ marginBottom: boolean }>`
  color: ${APP_COLORS.primary};
  cursor: default;
  user-select: none;
  font-size: 12px;
  ${props => (props.marginBottom ? `margin-bottom:10px` : ``)};
  & *:first-child {
    margin-right: 5px;
    cursor: pointer;
  }
  & *:last-child {
    margin-left: 5px;
    cursor: pointer;
  }
`;

export const StyledCollapseContainer = styled.span<{ open: boolean }>`
  position: absolute;
  z-index: 2;
  width: 200px;
  background-color: ${({ theme }) => theme.greyBackground};
  border-radius: 4px;
  border: 1px solid ${props => (props.open ? `#3675b4` : `#dae6e8`)};
  margin-top: -45px;
  padding: 0 5px;
  max-height: ${props => (props.open ? `260px` : `35px`)};
`;

export const CollapseHeader = styled.div`
  text-indent: 5px;
  height: 35px;
  word-wrap: break-word;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledArrowDown = styled(ArrowDown)`
  height: 24px;
  width: 24px;
  ${props => (props.flip ? `transform: rotate(0.5turn)` : undefined)};
`;

export const CollapseBody = styled.div<{ open: boolean }>`
  display: ${props => (props.open ? `block` : `none`)};
  max-height: 215px;
  height: 100%;
  & *:first-child {
    margin-top: 3px;
  }
`;

export const CollapseListWrapper = styled.div`
  overflow: auto;
  max-height: 170px;
  margin-bottom: 5px;
`;

export const Placeholder = styled.div`
  min-height: 55px;
`;
